import React from "react";
import '../../assets/css/style.css';
import Vipimg from '../../assets/img/vip2.svg';
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
const ProfileDan = () => {

const navigate = useNavigate();


const [namekarbar, setname] = useState("");
const [familikarbar, setfamilikarbar] = useState("");
const [emailkarbar, setemailkarbar] = useState("");
const [tephonekarbar, settephonekarbar] = useState("");
const [kodemelikarbar, setkodemelikarbar] = useState("");
const [adresskarbar, setadresskarbar] = useState("");
const [zipcodekarbar, setzipcodekarbar] = useState("");
const [Mytoken, setmytoken] = useState(null);





useEffect(() => {
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const usertoken = localStorage.getItem("donetoken");

    setname(userInfo.name);
    setfamilikarbar(userInfo.family);
    setemailkarbar(userInfo.email);
    settephonekarbar(userInfo.mobile);
    setkodemelikarbar(userInfo.nic_code);
    setadresskarbar(userInfo.address);
    setzipcodekarbar(userInfo.zip_code);
    setmytoken(usertoken);
  
}, []);



const UpdateuserData = async () => {
  if (!Mytoken) {
    alert("توکن کاربر یافت نشد، لطفاً دوباره وارد شوید.");
    return;
  }

  const updatedUserInfo = {
    name: namekarbar,
    family: familikarbar,
    email: emailkarbar,
    mobile: tephonekarbar,
    nic_code: kodemelikarbar,
    address: adresskarbar,
    zip_code: zipcodekarbar,
    token: Mytoken,
  };

  try {
    const response = await fetch('https://app.doneapp.ir/backend/update_profile.php', {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${Mytoken}`
      },
      body: JSON.stringify(updatedUserInfo),
    });

    const responseData = await response.json();
    console.log(responseData);

    if (response.ok) {
      alert(responseData.message || 'اطلاعات با موفقیت به‌روزرسانی شد!');
      localStorage.setItem("userinfo", JSON.stringify(updatedUserInfo));
    } else {
      alert(responseData.error || 'بروزرسانی اطلاعات ناموفق بود!');
    }
  } catch (error) {
    console.error('Error updating user data:', error);
    alert('یک خطا در هنگام بروزرسانی اطلاعات رخ داد.');
  }
};









  return (
    <>
   <div className="mohtava-mine" >
     
 <section id="shops" className="dir-r max-cntt-w" >
   
 <div className="gift-div-1" >
    <div className="gift-div-2" >
<button className="gift-ref-btn-1"  >
کاربر عادی

</button>

<button  onClick={() => navigate("/panel/vip")}
className="gift-ref-btn-2 flex-c"
>
ارتقا سطح کاربری به ویژه
<span className="span-vip" >
  <img src={Vipimg} alt="vip" />
  </span>
</button>

</div>

</div>
  
<div className="profile-div-1" >
            <p className="profile-p-1" >
                نام و نام خانوادگی:
            </p>
            <input type="text" className="profile-input-1" readonly value={`${namekarbar} ${familikarbar}`}  />
            <p className="profile-p-2" >
              ایمیل: </p>
              <input type="text" className="profile-input-2" readonly value={emailkarbar} /> 
              <p className="profile-p-3" >شماره تلفن:</p>
              <input type="text" className="profile-input-3"
             
              value={tephonekarbar} />
              <p className="profile-p-4" >کد ملی:</p>
        <input type="text" className="profile-input-4" 
        value={kodemelikarbar}
        onChange={(e) => setkodemelikarbar(e.target.value)}
        />
        <p className="profile-p-4" >آدرس محل سکونت:</p>
        <input type="text" className="profile-input-1 no-bg"
         value={adresskarbar}
         onChange={(e) => setadresskarbar(e.target.value)}
        />
        <p className="profile-p-4" >کد پستی: </p>
        <input  type="text" className="profile-input-4"
        
        value={zipcodekarbar}
        onChange={(e) => setzipcodekarbar(e.target.value)}
        />
        <button  className="profile-btn-1 mt-30"
        
        onClick={UpdateuserData}
        
        > 
        به روز رسانی و ذخیره اطلاعات    
    </button>
    </div>
 
 
 
       <div className="h-100">
           
       </div>
   
       </section>
 
   </div>
    </>
       
   );
};

export default ProfileDan;
